<template>
  <div class="statistical-box">
    <el-row>
      <el-col :span="12"><h3 class="title">工作概览 <svg-icon icon-class="help" /></h3></el-col>
      <el-col :span="12" style="text-align: right">
        <el-select v-model="selectedValue" placeholder="请选择" style="width: 140px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">
              电话接通率
            </div>
            <p class="ratio-txt"><span>0.00%</span></p>
            <div class="grey-bg">
              <p>接入会话量 --</p>
              <p>未接会话量 --</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">
              IM响应率
            </div>
            <p class="ratio-txt"><span>0.00%</span></p>
            <div class="grey-bg">
              <p>接入会话量 --</p>
              <p>未接会话量 --</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">
              短信响应率
            </div>
            <p class="ratio-txt"><span>0.00%</span></p>
            <div class="grey-bg">
              <p>接入会话量 --</p>
              <p>未接会话量 --</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">
              邮件响应率
            </div>
            <p class="ratio-txt"><span>0.00%</span></p>
            <div class="grey-bg">
              <p>接入会话量 --</p>
              <p>未接会话量 --</p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selectedValue: '当日数据概述',
      options: [
        {
          label: '当日数据概述',
          value: 1
        }
      ]
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
.statistical-box{
  // max-width: 980px;
}

.title{
  font-size: 24px;
  color: #3C4353;
  margin: 0px auto 10px auto;
  text-align: left;
  font-weight: bold;
}

.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    // height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    padding-top: 20px;
    text-align: center;

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .grey-bg{
      color: #3C4353;
      background: #efefef;
      padding: 10px 0;
      line-height: 30px;
      margin-top: 10px;
    }

    .ratio-txt{
      color: #337EFF;
      font-size: 30px;
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      // float: right;
      font-weight: bold;
      // margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
